import { render, staticRenderFns } from "./insurance_datum.vue?vue&type=template&id=b16a389a&"
import script from "./insurance_datum.vue?vue&type=script&lang=js&"
export * from "./insurance_datum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports